import React from 'react';
import ModalWrapper, { withOnClose } from './ModalWrapper';
import './styles/modalPurchaseSerie.scss';
import {
    Grid,
    Row,
    cls,
    Column,
    Button,
    ColoredButton,
    HeaderCompound
} from '../../packages/components';
import { getAndroidTvPolicesLabels, getAddonAndroidMessageClassNames } from '../../payments/utils/Utils';
import UtilsPagos from "../../utils/payway/UtilsPagos";
import Translator from '../../requests/apa/Translator';
import { Tab } from '../../packages/components/lib/Keyboard/Tab';
import { withRouter } from 'react-router';
import Asset from '../../requests/apa/Asset';
import {GA4} from '../../utils/trackers/GA4';
import {CONTENT_SECTION_VCARD} from '../../utils/trackers/GA4Constants';
    
const MAIN_CLASSNAME = 'aaf-modal-purchase-serie';

const ModalPurchaseSerie = ({ pbi = {} , serie = {} , handleClose = () => {}, history = {}, endPlayer = () => {}, yellowAction = () => {}, extraData = {} }) => {
    const {
        listButtons : {
            button: buttons = []
        } ={},
        groupId = undefined
    } = pbi;
    const {
        title = '',
        episode = ''
    } = serie;
    const modalProps = {
        childrenClassName: `${MAIN_CLASSNAME}-wrapper`,
        yellowAction : (e) => {yellowAction(e)}
    };

    window.SpatialNavigation.focus()

    const handleClick = (button) => {
        handleClose();
        endPlayer();
        sendGA4Metric(extraData, button);
        history.push(
            `/detailtransaction`, 
            {
                ...button,
                hideTextStep: true,
                backButtonAlign: 'right',
                groupId,
                extraDisclaimer: Translator.get('serie_my_content_disclamer', 'Podrás ver tu compra en la sección <bold>Mis contenidos</bold>')
            }
        );
    }

    const sendGA4Metric = (extraData, selectedButton) => {
        const gA4 = new GA4();
        const { groupId, name, category, category2, category3, category4, providerName} = extraData || {};
        const {price, producttype} = selectedButton || {};
        const isEpisode = producttype.includes('EPISODE');
        const category3Selected = isEpisode ? category3.episode: category3.season;
        const category4Selected = isEpisode ? category4.episode: category4.season;
        gA4.sendStartCheckoutEvent(groupId, name, category, category2, category3Selected, category4Selected, providerName, CONTENT_SECTION_VCARD, price, 1);
    }

    const handleBack = () => {
        handleClose();
    }

    const getAddonAndroidMessage = () => {
        const classes = {
            classNameContainer: `aaf-modal-purchase-serie-container-android-tv-policies`,
            classNameTitle: 'title-android-tv',
            classNameDescription: 'description-android-tv'
        };
    
        return getAddonAndroidMessageClassNames(getAndroidTvPolicesLabels(), classes);
    }
    const getPurchaseButtons = (buttons, CB) => {
        if (UtilsPagos.shouldShowAndroidMessage(buttons)){
            const getAddonAndroidMessage = CB();
            return([
            <div className='aaf-modal-purchase-serie-wrapper-android-tv-policies'>
              {getAddonAndroidMessage}
            </div>])
        } else {
            return buttons.map((button, index)=>(
                <Button
                    type="button"
                    variant={`purple-${index === 0 ? "1" : "2"}`}
                    className={cls(`focusable`)}
                    onClick={()=>handleClick(button)}
                    block
                >
                    {`${Translator.get(button.oneofferdesckey, '').replace('@frequency', button.frequency)} ${button.currency}${button.price}`}
                </Button>
            ))
        }
    }


    return (
        <ModalWrapper {...modalProps}>
            <Grid className={cls(`${MAIN_CLASSNAME}`)}>
                <HeaderCompound
                        disabled
                        align='left'
                        onClick={handleBack}
                        textBack={Translator.get('top_head_option_button_back', 'REGRESAR')}
                        icon={`${Asset.get('top_head_option_back')}`}
                />
                <Row className={cls(`${MAIN_CLASSNAME}-center`)}>
                    <Column lg={12} className={cls(`${MAIN_CLASSNAME}-title`)}>
                        { Translator.get('modal_purchase_serie_title', '¿Cómo quieres adquirir este contenido?') }
                    </Column>
                </Row>
                <Row className={cls(`${MAIN_CLASSNAME}-center`)}>
                    <Column lg={12} >
                        {
                            title && <span className={cls(`${MAIN_CLASSNAME}-subtitle`)}>
                                {title}
                            </span>
                        }
                        <br/>
                        {
                            episode && <span className={cls(`${MAIN_CLASSNAME}-title`)}>
                                {`(${episode})`}
                            </span>
                        }
                    </Column>
                </Row>
                <Row className={cls(`${MAIN_CLASSNAME}-center`)}>
                    <Column lg={2}/>
                    <Column lg={'1-5'}/>
                    <Column lg={5} className={cls(`${MAIN_CLASSNAME}-button`)}>
                        {
                            getPurchaseButtons(buttons, getAddonAndroidMessage)
                        }
                    </Column>
                    <Column lg={'1-5'}/>
                    <Column lg={2}/>
                </Row>
            </Grid>
        </ModalWrapper>
    );
}

export default withRouter(withOnClose(ModalPurchaseSerie));



// WEBPACK FOOTER //
// ./src/components/Modal/ModalPurchaseSerie.jsx